import {setLoading} from "../generalActions/mainActions";
import {addItem, changeListItem, removeItem, setItems, setTableParams} from "../generalActions/listActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {deleteErrorMsg, error} from "../../../components/i18n/i18n";
import {setForm} from "../generalActions/formActions";
import {utilHelper} from "../../../jwt/_helpers";
import {benefitService} from "../../../jwt/_services/promotions/benefitService";

export const search = (pageIndex, pageSize, filter) => ( dispatch ) => {
    dispatch(setLoading(true))

    benefitService.getPagedList(pageIndex, pageSize, filter)
        .then(result => {
            if (!result)
                return
            dispatch(setItems(result.data))
            dispatch(setTableParams(pageSize, pageIndex, result?.total))
        })
        .catch(errorMessage => {
            showToastCustom(error, errorMessage);
            console.log("Error",error)
        })
        .finally(() => dispatch(setLoading(false)))
}

export const save = (data) => ( dispatch ) => {
    dispatch(setLoading(true))

    benefitService.saveItem(data)
        .then(result => {
            dispatch( setForm(false, true, true) )
            dispatch( addItem(result) )
        })
        .catch(errorMessage => {
            showToastCustom(error, errorMessage);
            console.log("Error",error)
        })
        .finally(() => dispatch(setLoading(false)))

}

export const update = (id, data) => ( dispatch ) => {
    dispatch(setLoading(true))

    benefitService.updateItem(id, data)
        .then(result => {
            dispatch( setForm(false, true, true) )
            dispatch( changeListItem(result) )
        })
        .catch(errorMessage => {
            showToastCustom(error, errorMessage);
            console.log("Error",error)
        })
        .finally(() => dispatch(setLoading(false)))
}

export const remove = (id) => (dispatch) => {
    dispatch(setLoading(true))

    benefitService.deleteItem(id)
        .then(result => {
            if(result?.status)
                dispatch( removeItem(id) )

            if (utilHelper.hasAssociateRecords()) {
                showToastCustom(error, deleteErrorMsg, true);
                utilHelper.restartAssociateRecords();
            }
        })
        .catch(errorMessage => {
            showToastCustom(error, errorMessage);
            console.log("Error",error)
        })
        .finally(() => dispatch(setLoading(false)))
}
